
import React, { useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Search as SearchIcon } from 'lucide-react';
import { useSearch } from '../context/SearchContext';

export const SearchForm = () => {
  const { searchQuery, setSearchQuery, handleSearch } = useSearch();
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus input on component mount
  useEffect(() => {
    // Short delay to ensure DOM is ready
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="max-w-2xl mx-auto mb-8" itemScope itemType="https://schema.org/WebSite">
      <form 
        onSubmit={handleSearch} 
        className="relative" 
        itemProp="potentialAction" 
        itemScope 
        itemType="https://schema.org/SearchAction"
      >
        <meta itemProp="target" content={`${window.location.origin}/search?q={search_term_string}`} />
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
        <Input
          ref={inputRef}
          type="text"
          name="search_term_string"
          itemProp="query-input"
          placeholder="Search destinations, hosts..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 h-12 text-lg"
          aria-label="Search input"
        />
      </form>
    </div>
  );
};
